import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Scoped smooth-scroll. Mounts a Lenis instance for the lifetime of the
 * page that uses it, then fully destroys it on unmount so other pages
 * keep native scrolling untouched.
 */
export default function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.5,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}
